export default "/images/vendor/flag-icons/flags/4x3/gd.svg?65b4daaaa1cdb22074df4f3e0f09b2bd";